import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest } from '../../lib/common'
import {Constants, setTokenAlive} from './actions'
import {
  parserToken
} from '../../views/client/actions'

function* getData() {
  try {
    const request = axiosApi().post(
      Constants.GET_DATA_API,
      {
        token: parserToken(localStorage.getItem('token')).Token,
      }
    )
    const response = yield call(handleRequest, request);
    const { code } = response
    if (code === 200) {
      return yield put(setTokenAlive(true))
    } else {
      return yield put(setTokenAlive(false))
    }
  } catch (error) {
    return yield put(setTokenAlive(false))
  }
}

function* globalWatcher() {
  yield [
    takeLatest(Constants.GET_DATA, getData)
  ]
}

export default globalWatcher


// WEBPACK FOOTER //
// ./src/containers/Full/sagas.js